import { render, staticRenderFns } from "./addAllocation.vue?vue&type=template&id=ec54b57c&scoped=true&"
import script from "./addAllocation.vue?vue&type=script&lang=js&"
export * from "./addAllocation.vue?vue&type=script&lang=js&"
import style0 from "./addAllocation.vue?vue&type=style&index=0&id=ec54b57c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec54b57c",
  null
  
)

export default component.exports